import React, { useEffect, useContext, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Cached from '@mui/icons-material/Cached'
import Tooltip from '@mui/material/Tooltip'
import { v4 as uuid } from 'uuid'
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

import { routes } from 'config/routes'
import { ShellContext } from 'contexts/ShellContext'
import { PeerNameDisplay } from 'components/PeerNameDisplay'
import { ReactComponent as Logo } from 'img/logo.svg'

interface HomeProps {
  userId: string
}

export function Home({ userId }: HomeProps) {
  const { setTitle } = useContext(ShellContext)
  const [roomName, setRoomName] = useState(uuid())
  const navigate = useNavigate()

  useEffect(() => {
    setTitle('Black-Chat')
  }, [setTitle])

  const handleRoomNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setRoomName(value)
  }

  const handleFormSubmit = (event: React.SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault()
  }

  const handleJoinPublicRoomClick = () => {
    navigate(`/public/${roomName}`)
  }

  const handleJoinPrivateRoomClick = () => {
    navigate(`/private/${roomName}`)
  }

  const isRoomNameValid = roomName.length > 0

  return (
    <Box className="Home">
      <main className="mt-6 px-4 max-w-3xl text-center mx-auto">
        <Link to={routes.ABOUT}>
          <Logo className="px-1 pb-4 mx-auto max-w-md" />
        </Link>
        <form onSubmit={handleFormSubmit} className="max-w-xl mx-auto">
          <Typography sx={{ mb: 2 }}>
            Your user name:{' '}
            <PeerNameDisplay paragraph={false} sx={{ fontWeight: 'bold' }}>
              {userId}
            </PeerNameDisplay>
          </Typography>
          <FormControl fullWidth>
            <Tooltip title="Default room names are randomly generated client-side">
              <TextField
                label="Room name"
                variant="outlined"
                value={roomName}
                onChange={handleRoomNameChange}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      aria-label="Regenerate room id"
                      onClick={() => setRoomName(uuid())}
                      size="small"
                    >
                      <Cached />
                    </IconButton>
                  ),
                  sx: { fontSize: { xs: '0.9rem', sm: '1rem' } },
                }}
                size="medium"
              />
            </Tooltip>
          </FormControl>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              onClick={handleJoinPublicRoomClick}
              sx={{
                marginTop: 2,
                backgroundColor: "#F24900",
                '&:hover': {
                  backgroundColor: '#F26E00',
              },
              }}
              disabled={!isRoomNameValid}
            >
              Join public room
            </Button>
            <Button
              variant="contained"
              onClick={handleJoinPrivateRoomClick}
              sx={{
                marginTop: 2,
                marginLeft: 2,
                backgroundColor: "#F24900",
                '&:hover': {
                  backgroundColor: '#F26E00',
              },
              }}
              disabled={!isRoomNameValid}
            >
              Join private room
            </Button>
          </Box>
        </form>
      </main>
      <Divider sx={{ my: 2 }} />
      <Box className="max-w-3xl text-center mx-auto px-4">
        <Typography variant="body1">
          Application developed by <strong>Kamran Saif</strong>
        </Typography>
        

        <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <IconButton
              aria-label="delete" 
              size="large"
              target="_blank"
              href="https://github.com/kamrangondal"
              sx={{
                marginTop: 2,
                backgroundColor: "#121212",
                '&:hover': {
                  backgroundColor: '#F26E00',
              },
              }}
            >
              <GitHubIcon />
            </IconButton >
            <IconButton 
              aria-label="delete" 
              size="large"
              target="_blank"
              href="https://www.linkedin.com/in/kamran-saif/"
              sx={{
                marginTop: 2,
                marginLeft: 2,
                backgroundColor: "#121212",
                '&:hover': {
                  backgroundColor: '#F26E00',
              },
              }}
            >
              <LinkedInIcon />
            </IconButton >
          </Box>
      </Box>
    </Box>
  )
}
